import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FormField, FormGrid, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { createAppModal } from 'utils/modal';
import styles from './createTagModal.module.scss';
/** A component that displays a modal for creating new tags. */
export const CreateTagModal = createAppModal({ type: 'app:createTag' }, ({ isOpen, modal, meta, hide }) => {
    const [tagName, setTagName] = useState(modal.arg.name || '');
    const handleTagNameChange = (event) => {
        var _a;
        setTagName((_a = event === null || event === void 0 ? void 0 : event.target.value) !== null && _a !== void 0 ? _a : '');
    };
    const handleConfirm = () => {
        meta === null || meta === void 0 ? void 0 : meta.resolve({ tag: { name: tagName, color: null } });
        handleCancel();
    };
    const handleCancel = useCallback(() => {
        setTagName('');
        hide === null || hide === void 0 ? void 0 : hide();
    }, [hide]);
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleCancel, className: styles.modal }, { children: [_jsx(ModalHead, { onClose: handleCancel, title: "Add new tag" }), _jsx(ModalBody, { children: _jsx(FormGrid, { children: _jsx(FormField, { children: _jsx(FieldText, { type: "text", input: {
                                name: 'tagName',
                                value: tagName,
                                onChange: handleTagNameChange,
                            }, label: "Tag name", placeholder: "Tag name", maxLength: 255, required: true }) }) }) }), _jsx(ModalFoot, { confirmOnClick: handleConfirm, cancelOnClick: handleCancel, confirmName: "Confirm", cancelName: "Cancel", confirmProps: {
                    disabled: !tagName,
                } })] })));
});
